import type { DynamicPricingMode } from '@/shared/api';
import { stamp } from './configurationFormat';
import { SECTION_SHORT, type SectionKey } from './configurationSections';
import type { PricingConfigurationFormProps } from './pricingConfigurationFormProps';
import type { ReleaseInput } from './releaseRailModel';

/** Eingabe des Freigabewegs aus dem geladenen Stand, dem Entwurf und der frischen Vorschau. */
export function releaseInput(
  props: Pick<
    PricingConfigurationFormProps,
    'configuration' | 'versionNumber' | 'effectiveFrom' | 'saved'
  >,
  draft: { mode: DynamicPricingMode; dirty: boolean; changed: SectionKey[]; previewAt?: string },
): ReleaseInput {
  return {
    mode: draft.mode,
    savedMode: props.configuration.mode,
    dirty: draft.dirty,
    changedSections: draft.changed.map((key) => SECTION_SHORT[key]),
    versionNumber: props.versionNumber,
    activeSince: `seit ${stamp(props.effectiveFrom)}`,
    previewedAt: draft.previewAt ? stamp(draft.previewAt) : null,
    saved: props.saved ? { ...props.saved, previewedAt: stamp(props.saved.previewedAt) } : null,
  };
}
